import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TtAvatar, TtIcon } from '@23/ui-react'

import { useAudienceMemberQuery } from '../blocs/useAudience'

import './AudienceMemberListItem.scss'

interface AudienceMemberListItemProps {
  uuid: string
}

const AudienceMemberListItem = ({ uuid }: AudienceMemberListItemProps) => {
  const { data: member } = useAudienceMemberQuery(uuid)

  if (!member) return null

  const seconds = member.timelineEngagement
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)

  const firstName = member.profile?.firstname ?? ''
  const lastName = member.profile?.lastname ?? ''
  const identifier = `${firstName} ${lastName}`

  return (
    <a
      className="audience-member-list-item-link"
      href={`/audience/${member.uuid}`}
      target="_blank"
      rel="noopener noreferrer"
      key={member.uuid}
    >
      <div className="audience-member-list-item">
        <TtAvatar label={identifier} size="xl" shape="rounded" autoColor />
        <div className="audience-member-details">
          <div className="audience-member-name">
            {member.profile?.firstname} {member.profile?.lastname}
          </div>
          <div className="audience-member-subline">
            <TtIcon
              className="audience-member-flag"
              library="one/flags"
              name={member.profile?.countryCode}
            />
            <div className="audience-member-email">{member.email}</div>
          </div>
          <div className="audience-member-stats">
            <div className="audience-member-views">
              <FormattedMessage
                defaultMessage="{views} views"
                values={{ views: member.views }}
              />
            </div>
            •
            <div className="audience-member-engagement">
              <FormattedMessage
                defaultMessage="{time} total engagement"
                values={{
                  time: hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}

export { AudienceMemberListItem }
